import { raffleImages } from "../../lib/raffleImages";

export const localDateTime = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const validRaffleImageUrl = (value) => {
    const url = value.trim();
    if (!url) return true;
    if (url.length > 2048 || /[\s\\]/.test(url)) return false;
    // Keep storage paths relative, so existing uploads remain portable between environments.
    if (/^\/api\/files\/[^\s\\]+$/.test(url)) return true;
    try { return ["https:", "http:"].includes(new URL(url).protocol); }
    catch { return false; }
};

export const initialRaffleValues = (raffle) => ({
    name: raffle?.name || "",
    slug: raffle?.slug || "",
    description: raffle?.description || "",
    prize_description: raffle?.prize_description || "",
    prize_source: raffle?.prize_source || "",
    prize_value_usd: raffle?.prize_value_usd ?? "",
    prize_image_urls: raffleImages(raffle),
    new_image_url: "",
    ticket_price_usd: raffle?.ticket_price_usd ?? "10",
    max_tickets_per_person: raffle?.max_tickets_per_person ?? 10,
    claim_deadline_days: raffle?.claim_deadline_days ?? 30,
    starts_at: localDateTime(raffle?.starts_at),
    ends_at: localDateTime(raffle?.ends_at),
    campaign_id: raffle?.campaign_id || "",
});

export const raffleFormPayload = (form, original) => {
    // A pasted URL is included on Save even if the administrator has not clicked +.
    const images = [...new Set([...form.prize_image_urls, form.new_image_url.trim()].filter(Boolean))];
    const dateValue = (key) => {
        // Preserve the exact saved instant, including seconds, if it was not edited.
        if (original?.[key] && form[key] === localDateTime(original[key])) return original[key];
        return form[key] ? new Date(form[key]).toISOString() : null;
    };
    return {
        name: form.name.trim(), slug: form.slug.trim() || null,
        description: form.description.trim(), prize_description: form.prize_description.trim(),
        prize_source: form.prize_source.trim(), prize_image_urls: images, prize_image_url: images[0] || "",
        prize_value_usd: form.prize_value_usd === "" ? null : Number(form.prize_value_usd),
        ticket_price_usd: Number(form.ticket_price_usd),
        max_tickets_per_person: Number(form.max_tickets_per_person),
        claim_deadline_days: Number(form.claim_deadline_days),
        campaign_id: form.campaign_id || null,
        starts_at: dateValue("starts_at"), ends_at: dateValue("ends_at"),
    };
};